import React from 'react';

import MemoryCard from '../MemoryCard';

import { formatDate } from '../../helpers';
import { memoryPlaceholders } from '../../helpers/memory';

import type { Asset } from '../../types/asset';
import type { MemoryCardProps } from '../../types/props/memorycard';
import type { MemoryDataForm } from '../../types/forms/memorydataform';

interface MemoryPreviewProps {
  memoryData: MemoryDataForm;
  watch: Function;
  files: Asset[];
  isEditMode?: boolean;
  touchedFields?: Record<string, boolean>;
};
const MemoryPreview: React.FC<MemoryPreviewProps> = ({ files, watch, isEditMode, touchedFields }) => {
  const fields: MemoryCardProps = {
    variant: watch('variant') as string,
    title: (watch('title') as string) || (isEditMode || touchedFields?.title ? '' : '<placeholder>'),
    content: (watch('content') as string) || (isEditMode || touchedFields?.content ? '' : '<placeholder>'),
    name: (watch('name') as string) || memoryPlaceholders.name,
    dedicated_to: (watch('dedicated_to') as string) || (isEditMode || touchedFields?.dedicated_to ? '' : '<placeholder>'),
    date: watch('date') ? formatDate(watch('date')) : formatDate(new Date().toISOString()),
    tags: watch('tags') ? (watch('tags') as number[]).filter(Boolean) : [],
    allow_comments: watch('allow_comments') !== undefined ? (watch('allow_comments') as boolean) : true,
    allow_reactions: watch('allow_reactions') !== undefined ? (watch('allow_reactions') as boolean) : true,
    type: watch('type') as string,
    assets: watch('assets') ? (watch('assets') as string[]) : [],
    files: files,
  }

  return (
    <div className="memory-preview-container">
      <MemoryCard {...fields} />
    </div>
  );
}

export default MemoryPreview;
